import { render, staticRenderFns } from "./frozenmoney.vue?vue&type=template&id=77614ccd&"
import script from "./frozenmoney.vue?vue&type=script&lang=ts&"
export * from "./frozenmoney.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports